function SvgPrivateCloud(props) {
  return (
    <svg height="1em" viewBox="0 0 48 37" width="1em" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M16.101 1c1.867 0 3.657.528 5.2 1.462a10.264 10.264 0 014.3 5.194 7.872 7.872 0 015.93-2.699c2.18 0 4.156.896 5.587 2.341a8.011 8.011 0 012.323 5.653c0 .343-.022.685-.064 1.022h0l-.157 1.265 1.265-.148a5.795 5.795 0 014.8 1.687A5.903 5.903 0 0147 20.946c0 1.626-.656 3.1-1.715 4.168a5.795 5.795 0 01-4.125 1.726h0H6.83a5.78 5.78 0 01-4.117-1.725 5.908 5.908 0 01-.42-7.848 5.845 5.845 0 013.288-2.072c.37-.082.744-.126 1.116-.134a10.265 10.265 0 01-.727-3.826c0-2.823 1.137-5.383 2.974-7.237A10.048 10.048 0 0116.101 1z"
          stroke="#3A3F4C"
          strokeWidth={2}
        />
        <path
          d="M16.97 23.21h15.02c.307 0 .537.241.537.564V33.94c0 .323-.23.565-.536.565H16.969c-.306 0-.536-.242-.536-.565V23.774c0-.323.23-.565.536-.565m7.511-9.6c2.684 0 4.828 2.257 4.828 5.083v3.388h-9.656v-3.388c0-2.826 2.144-5.083 4.828-5.083m0-1.129c-3.26 0-5.901 2.78-5.901 6.212v3.388h-1.61c-.882 0-1.609.765-1.609 1.694V33.94c0 .928.727 1.694 1.61 1.694h15.02c.883 0 1.61-.766 1.61-1.694V23.774c0-.929-.727-1.694-1.61-1.694h-1.609v-3.388c0-3.432-2.641-6.212-5.901-6.212"
          stroke="#3A3F4C"
          strokeWidth={1.18}
        />
        <path d="M16.992 23.78H31.97v10.166H16.992z" fill="#FFF" />
      </g>
    </svg>
  )
}

export default SvgPrivateCloud
